import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../context/ThemeContext";
function TabComponent(props) {
  const { enableSeparator = false } = props;
  const { theme } = useTheme();
  const { t } = useTranslation();

  let tabElement = props.default ? props.default : Object.keys(props.tabs)[0];
  const [tab, setTab] = useState(tabElement);

    useEffect(() => {
      window.history.pushState(
        { tab: tab },
        "",
        window.location.href
      );
    },[tab])

  let ele = "";
  if (!props.tab) {
    ele = Object.keys(props.tabs).filter((ele) => ele === tab)[0];
    if (!ele) {
      ele = Object.keys(props.tabs)[0];
    }
  }

  const nodpadding = props.nopadding ? "" : "mt-4";

  return (
    <>
      <ul
        className={
          (props.noBorder === true
            ? "nav nav-tabs  flex flex-col gap-8  md:flex-row flex-wrap list-none pl-0"
            : "nav nav-tabs  flex flex-col gap-8  border-b  md:flex-row flex-wrap list-none pl-0") +
          ` ${nodpadding}`
        }
        role="tablist"
        onClick={(event) => {
          if (event.target.id !== "") {
            if (props.setSelectedTabId) {
              props.setSelectedTabId(event.target.id);
            } else {
              setTab(event.target.id);

              props.selectedTabId && props.selectedTabId(event.target.id);
            }
          }
        }}
      >
        {Object.keys(props.tabs).map((ele, i) => {
          return (
            <Fragment key={i}>
              {props.tab ? (
                <li
                  style={
                    props.tab === ele
                      ? {
                          borderBottom: props.highlightColor
                            ? `1px solid ${props.highlightColor}`
                            : `1px solid ${theme.primaryColor}`,
                        }
                      : {}
                  }
                  key={i}
                  role="presentation"
                >
                  <div
                    style={
                      props.tab === ele
                        ? {
                            color: props.highlightColor
                              ? props.highlightColor
                              : theme.primaryColor,
                          }
                        : {}
                    }
                    className={
                      props.tab === ele
                        ? " nav-link block cursor-pointer font-bold text-sm leading-tight border-x-0 border-t-0 border-b-2 border-transparent  pb-1 focus:border-transparent active"
                        : " nav-link block cursor-pointer text-sm leading-tight text-[#7B7B7B] border-x-0 border-t-0 border-b-2 border-transparent pb-1 focus:border-transparent active"
                    }
                    role="tab"
                    id={ele}
                    aria-selected="true"
                  >
                    {props.noTranslate ? ele : t(ele)}
                  </div>
                </li>
              ) : (
                <li
                  style={
                    tab === ele
                      ? {
                          borderBottom: props.highlightColor
                            ? `1px solid ${props.highlightColor}`
                            : `1px solid ${theme.primaryColor}`,
                        }
                      : {}
                  }
                  key={i}
                  role="presentation"
                >
                  <div
                    style={
                      tab === ele
                        ? {
                            color: props.highlightColor
                              ? props.highlightColor
                              : theme.primaryColor,
                          }
                        : {}
                    }
                    className={
                      tab === ele
                        ? " nav-link block cursor-pointer font-bold text-sm leading-tight border-x-0 border-t-0 border-b-2 border-transparent pb-1 focus:border-transparent active"
                        : " nav-link block cursor-pointer text-sm leading-tight text-[#7B7B7B] border-x-0 border-t-0 border-b-2 border-transparent pb-1 focus:border-transparent active"
                    }
                    role="tab"
                    id={ele}
                    aria-selected="true"
                  >
                    {props.noTranslate ? ele : t(ele)}
                  </div>
                </li>
              )}
              {enableSeparator ? (
                Object.keys(props.tabs).length - 1 === i ? null : (
                  <li
                    style={{
                      width: "1px",
                      height: "20px",
                      backgroundColor: "#7B7B7B",
                      margin: "0px 4px",
                    }}
                  />
                )
              ) : null}
            </Fragment>
          );
        })}
      </ul>
      {props.tab ? props.tabs[props.tab] : props.tabs[ele]}
    </>
  );
}
export default TabComponent;
